import axios from 'axios';
import { supabase } from '../auth/supabaseClient';

// Create dedicated axios instance for Library API calls
const libraryHttp = axios.create({
  baseURL: '/api'  // Will be proxied to Library service
});

// Inject the logged-in user's Supabase access token on every request
// (mirrors identityContract.js seam reads and the capture interceptor).
libraryHttp.interceptors.request.use(async (config) => {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Library API functions that match the working Document Library
export const documentAPI = {
  // Get document metadata and extracted fields
  getDocument: async (documentId) => {
    console.log('[Library API] Fetching document:', documentId);
    
    const response = await libraryHttp.get(`/documents/${documentId}`);
    return response.data;
  },
};

// Field API for unified fields
export const fieldApi = {
  getDocumentFields: async (documentId) => {
    console.log('[Library API] Fetching unified fields:', documentId);
    
    const response = await libraryHttp.get(`/fields/documents/${documentId}`);
    return response.data;
  },
};

// Error handling helper
export const handleAPIError = (error, context = 'API call') => {
  console.error(`[${context}] Error:`, error);
  
  if (error.response) {
    // Server responded with error status
    const message = error.response.data?.error || error.response.data?.message || 'Server error';
    return {
      type: 'server_error',
      message,
      status: error.response.status,
      details: error.response.data,
    };
  } else if (error.request) {
    // Network error
    return {
      type: 'network_error',
      message: 'Network error - check if services are running',
      details: error.message,
    };
  } else {
    // Other error
    return {
      type: 'unknown_error',
      message: error.message || 'Unknown error occurred',
      details: error,
    };
  }
};
